<template>
  <div
    class="single-item-images-wrapper"
    :class="{ 'overlay-image-opened': showOverlay || showBackgroundOverlay }"
  >
    <div class="single-item-images">
      <div class="main-image position-relative">
        <div
          v-if="topItemTags.length > 0"
          class="position-absolute item-tags-top"
        >
          <div class="d-flex flex-column text-center item-tags">
            <span
              class="item-tag small"
              v-for="tag in topItemTags"
              :key="tag.selectionId"
            >
              {{ tag.value }}
            </span>
          </div>
        </div>
        <div
          id="singleItemCarouselImages"
          class="carousel slide"
          data-ride="carousel"
          :data-interval="5000"
          @mouseenter="stopCarousel"
          @mouseleave="startCarousel"
        >
          <div class="position-relative mx-auto" style="max-width: fit-content">
            <div
              class="carousel-inner"
              @mousemove="handleMouseMove"
              @mouseleave="handleMouseLeave"
            >
              <div
                v-for="(item, index) in previewImages"
                :key="index"
                :class="{ 'carousel-item': true, active: index === 0 }"
                @click="openOverlay(index)"
              >
                <img
                  class="d-block w-100"
                  :src="item"
                  :alt="name"
                  :loading="index === 0 ? 'eager' : 'lazy'"
                  fetchpriority="high"
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div
                class="hover-box"
                v-if="showHoverBox"
                :style="hoverBoxStyle"
              ></div>
            </div>
          </div>
          <button
            class="carousel-control carousel-control-prev"
            data-target="#singleItemCarouselImages"
            data-slide="prev"
            aria-label="Previous"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#121926"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            class="carousel-control carousel-control-next"
            data-target="#singleItemCarouselImages"
            data-slide="next"
            aria-label="Next"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#121926"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <ol class="carousel-indicators">
            <li
              v-for="(_, index) in previewImages"
              :key="index"
              data-target="#singleItemCarouselImages"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
        </div>
        <div
          v-if="showHoverBox"
          class="zoom-image"
          :style="{
            backgroundImage: 'url(' + selectedImage + ')',
            ...zoomImageStyle,
          }"
        ></div>
        <a
          v-if="videoId"
          :href="'https://www.youtube.com/embed/' + videoId"
          target="_blank"
          rel="noopener noreferrer"
          class="video-preview"
          aria-label="video preview"
        >
          <svg
            width="50"
            height="50"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_567_26611)">
              <circle cx="32" cy="28" r="24" fill="#f53d3d"></circle>
            </g>
            <path
              d="M39.7199 27.663C40.3236 28.0577 40.3236 28.9422 39.7199 29.3369L29.5473 35.9883C28.8821 36.4232 28 35.946 28 35.1514L28 21.8486C28 21.054 28.8821 20.5768 29.5472 21.0117L39.7199 27.663Z"
              fill="#ffffff"
            ></path>
            <defs>
              <filter
                id="filter0_d_567_26611"
                x="0"
                y="0"
                width="64"
                height="64"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood
                  flood-opacity="0"
                  result="BackgroundImageFix"
                ></feFlood>
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                ></feColorMatrix>
                <feOffset dy="4"></feOffset>
                <feGaussianBlur stdDeviation="4"></feGaussianBlur>
                <feComposite in2="hardAlpha" operator="out"></feComposite>
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                ></feColorMatrix>
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_567_26611"
                ></feBlend>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_567_26611"
                  result="shape"
                ></feBlend>
              </filter>
            </defs>
          </svg>
        </a>
      </div>
      <div
        class="thumbnail-images justify-content-md-center justify-content-lg-start"
      >
        <div
          v-for="(item, index) in carouselImages"
          :key="index"
          class="thumbnail-image overflow-hidden"
          data-target="#singleItemCarouselImages"
          :data-slide-to="index"
          :class="{ active: index === selectedIndex }"
        >
          <img
            class="img-fluid"
            :src="item"
            :alt="name"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
    <div
      v-if="bottomItemTags.length > 0"
      class="d-flex align-items-center justify-content-center flex-wrap text-center item-tags my-3"
    >
      <div
        class="d-inline-flex align-items-center justify-content-center item-tag"
        v-for="tag in bottomItemTags"
        :key="tag.selectionId"
      >
        <img
          v-if="tag.selectionId == 2809"
          src=""
          v-lazyload-img
          data-src="https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/hand-palm.png"
          :alt="tag.value"
          loading="lazy"
          decoding="async"
          width="20"
          height="20"
        />
        <img
          v-if="tag.selectionId == 2810"
          src=""
          v-lazyload-img
          data-src="https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/hand-tap.png"
          :alt="tag.value"
          loading="lazy"
          decoding="async"
          width="20"
          height="20"
        />
        <img
          v-if="tag.selectionId == 2811"
          src=""
          v-lazyload-img
          data-src="https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/wool.png"
          :alt="tag.value"
          loading="lazy"
          decoding="async"
          width="20"
          height="20"
        />
        <img
          v-if="tag.selectionId == 2812"
          src=""
          v-lazyload-img
          data-src="https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/towel.png"
          :alt="tag.value"
          loading="lazy"
          decoding="async"
          width="20"
          height="20"
        />
        <span class="small">{{ tag.value }}</span>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center mb-2 mr-2 mt-1"
    >
      <series-badge :item-id="itemId"></series-badge>
      <button
        @click="openBackgroundOverlay"
        class="button-overlay-background d-inline-flex ml-auto align-items-center"
      >
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
          />
        </svg>
        <span class="ml-2 small">
          {{ multiLanguage.ProductBackgroundVariations }}
        </span>
      </button>
    </div>

    <div v-if="showOverlay" class="overlay-wrapper">
      <item-image-overlay
        :visible="showOverlay"
        :carousel-images="carouselImages"
        :preview-images="previewImages"
        :selected-index="selectedIndex"
        :name="name"
        @close-overlay="closeOverlay"
      ></item-image-overlay>
    </div>
    <div v-if="showBackgroundOverlay" class="overlay-wrapper">
      <item-background-overlay
        :visible="showBackgroundOverlay"
        :selected-image="previewImages[0]"
        :name="name"
        @close-background-overlay="closeBackgroundOverlay"
      ></item-background-overlay>
    </div>
  </div>
</template>

<script>
export default {
  name: "item-image-carousel",
  components: {
    "series-badge": () => import("./SeriesBadge.vue"),
    "item-image-overlay": () => import("./ItemImageOverlay.vue"),
    "item-background-overlay": () => import("./ItemBackgroundOverlay.vue"),
  },
  props: {
    imageUrlsData: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    itemId: {
      default: null,
    },
    multiLanguage: Object,
  },
  data() {
    return {
      selectedImage: null,
      selectedIndex: 0,
      zoomImageStyle: {},
      showHoverBox: false,
      hoverBoxStyle: {},
      showOverlay: false,
      showBackgroundOverlay: false,
    };
  },
  computed: {
    carouselImages() {
      return this.$props.imageUrlsData.map((item) => item.urlPreview);
    },
    previewImages() {
      return this.$props.imageUrlsData.map((item) => item.url);
    },
    videoId() {
      const variation =
        this.$store.getters[`${this.$props.itemId}/currentItemVariation`];
      if (
        variation &&
        variation.variationProperties &&
        variation.variationProperties.length > 0
      ) {
        const vidProp = variation.variationProperties[0]?.properties.filter(
          (item) => item.id === 690
        );

        if (vidProp.length > 0 && vidProp[0].values.value) {
          return vidProp[0].values.value.substring(2);
        }
        return null;
      }
      return null;
    },
    topItemTags() {
      return this.getItemTags([2806, 2807, 2808, 2813, 2814]);
    },
    bottomItemTags() {
      return this.getItemTags([2809, 2810, 2811, 2812]);
    },
  },
  methods: {
    openOverlay(index) {
      this.selectedIndex = index;
      this.showOverlay = true;
      document.body.classList.add("fixed-active");
    },
    closeOverlay() {
      this.showOverlay = false;
      document.body.classList.remove("fixed-active");
    },
    openBackgroundOverlay() {
      this.showBackgroundOverlay = true;
      document.body.classList.add("fixed-active");
    },
    closeBackgroundOverlay() {
      this.showBackgroundOverlay = false;
      document.body.classList.remove("fixed-active");
    },
    stopCarousel() {
      $("#singleItemCarouselImages").carousel("pause");
    },
    startCarousel() {
      $("#singleItemCarouselImages").carousel("cycle");
    },
    handleMouseMove(event) {
      const { left, top, width, height } = event.target.getBoundingClientRect();
      const { clientX, clientY } = event;

      const hoverBoxSize = 150;

      let hoverBoxLeft = clientX - hoverBoxSize / 2 - left;
      let hoverBoxTop = clientY - hoverBoxSize / 2 - top;

      hoverBoxLeft = Math.max(0, Math.min(hoverBoxLeft, width - hoverBoxSize));
      hoverBoxTop = Math.max(0, Math.min(hoverBoxTop, height - hoverBoxSize));

      const xPercentage = (hoverBoxLeft / (width - hoverBoxSize)) * 100;
      const yPercentage = (hoverBoxTop / (height - hoverBoxSize)) * 100;

      this.hoverBoxStyle = {
        left: `${hoverBoxLeft}px`,
        top: `${hoverBoxTop}px`,
        width: `${hoverBoxSize}px`,
        height: `${hoverBoxSize}px`,
      };

      this.showHoverBox = true;

      this.zoomImageStyle = {
        backgroundPosition: `${xPercentage}% ${yPercentage}%`,
        backgroundSize: `${width / 1.5}% ${height / 1.5}%`,
      };
    },
    handleMouseLeave() {
      this.showHoverBox = false;
    },
    getItemTags(selectionIds) {
      const variation =
        this.$store.getters[`${this.$props.itemId}/currentItemVariation`];
      const properties = variation?.variationProperties?.[1]?.properties || [];
      const itemTags = properties.find((item) => item.id === 830)?.values || [];
      return itemTags.filter((tag) => selectionIds.includes(tag.selectionId));
    },
  },
  mounted() {
    this.$nextTick(() => {
      $("#singleItemCarouselImages").carousel();

      this.selectedImage = this.previewImages[0];

      $("#singleItemCarouselImages").on("slid.bs.carousel", (event) => {
        const activeItem = $(event.relatedTarget);
        this.selectedImage = activeItem.find("img").attr("src");
        this.selectedIndex = activeItem.index();
      });
    });
  },
  watch: {
    imageUrlsData: {
      handler(newVal) {
        this.selectedImage = newVal[this.selectedIndex].url;
      },
      immediate: true,
    },
  },
};
</script>
